/* eslint-disable no-unused-vars */
import BaseStore from './BaseStore';
import { List, Record } from 'immutable';
import { ActionTypes } from '../constants/AppConstants';

import { compareTrips } from '../components/widget/openTicketSelection/OpenTicketSelector';

const DefaultOpenGolfState = new Record({
    error: null,
    isLoadingTickets: false,
    loadingTrips: new List(),
    tickets: null
});

export class OpenGolfStore extends BaseStore {
    deserialize() {
        return new DefaultOpenGolfState();
    }

    handleAddTrip({ trip }) {
        this.setState(this.state.merge({
            loadingTrips: this.getLoadingTrips().push(trip)
        }));
    }

    handleOrderCreated() {
        this.setState(this.state.merge({
            loadingTrips: new List()
        }));
    }

    handleOrderTripCreated({ trip }) {
        this.setState(this.state.merge({
            loadingTrips: new List()
        }));
    }

    handleOrderTripDeleted({ orderTrip: trip }) {
        this.setState(this.state.merge({
            loadingTrips: new List()
        }));
    }

    handleGetTicketsStarted() {
        this.setState(this.state.merge({
            error: null,
            isLoadingTickets: true
        }));
    }

    handleGetTicketsEnded({ tickets }) {
        this.setState(this.state.merge({
            tickets,
            isLoadingTickets: false
        }));
    }

    handleGetTicketsFailed({ error }) {
        this.setState(this.state.merge({
            error,
            isLoadingTickets: false
        }));
    }

    getActionHandlers() {
        return {
            [ActionTypes.OPEN_GOLF_GET_TICKETS_STARTED]: this.handleGetTicketsStarted,
            [ActionTypes.OPEN_GOLF_GET_TICKETS_ENDED]: this.handleGetTicketsEnded,
            [ActionTypes.OPEN_GOLF_GET_TICKETS_FAILED]: this.handleGetTicketsFailed,
            [ActionTypes.OPEN_GOLF_ADD_TRIP]: this.handleAddTrip,
            [ActionTypes.ORDER_CREATED]: this.handleOrderCreated,
            [ActionTypes.ORDER_TRIP_CREATED]: this.handleOrderTripCreated,
            [ActionTypes.ORDER_TRIP_DELETED]: this.handleOrderTripDeleted
        };
    }

    getError() {
        return this.get('error');
    }

    getIsLoadingTickets() {
        return this.get('isLoadingTickets');
    }

    getLoadingTrips() {
        return this.get('loadingTrips');
    }

    getTickets() {
        return this.get('tickets');
    }
}

const instance = new OpenGolfStore();

export default instance;



// WEBPACK FOOTER //
// ./src/stores/OpenGolfStore.js